<div class="container-fluid login">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-10 offset-lg-1">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <form [formGroup]="loginForm" (ngSubmit)="login()" class="col-12 col-lg-6 offset-lg-3">
                                <h3>{{ 'login.sign_in' | translate }}</h3>
                                <span *ngIf="!success" class="error_login">
                                    {{errMessage}}{{ 'login.err_one' | translate }}
                                </span>
                                <span *ngIf="!roleError" class="error_login">
                                    {{ 'login.err_two' | translate }}
                                </span>
                                <div class="form-group mb-3">
                                    <label for="email">{{ 'user.email' | translate }}</label>
                                    <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        class="form-control"
                                        aria-describedby="emailHelp"
                                        formControlName="email"
                                        required
                                    >
                                </div>
                                <div *ngIf="submitted && fields.email.errors" class="errors_email">
                                    <span *ngIf="fields.email.errors.required">
                                        {{ 'login.err_three' | translate }}
                                    </span>
                                    <span *ngIf="fields.email.errors.email">
                                        {{ 'login.err_four' | translate }}
                                    </span>
                                    <div *ngIf="incorrectAttempt" class="errors_email">
                                        <span>{{ 'login.err_four' | translate }}</span>
                                    </div>
                                </div>
                                <div class="form-group mb-3">
                                    <label for="">{{ 'login.pwd' | translate }}</label>
                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        class="form-control"
                                        [ngClass]="submitted && fields.password.errors ? 'error-field' : ''"
                                        aria-describedby="passwordHelp"
                                        formControlName="password"
                                        required
                                    >
                                </div>
                                <div *ngIf="submitted && fields.password.errors" class="errors_pwd">
                                    <span *ngIf="fields.password.errors.required">
                                        {{ 'login.err_five' | translate }}
                                    </span>
                                    <span *ngIf="fields.password.errors.minlength">
                                        {{ 'login.err_six' | translate }}
                                    </span>
                                    <div *ngIf="incorrectAttempt" class="errors_pwd">
                                        <span>{{ 'login.err_five' | translate }}</span>
                                    </div>
                                </div>
                                <div class="mb-3 mt-3 text-end">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                    >
                                        {{ 'login.sign_in' | translate }}
                                    </button>
                                </div>
                                <div class="mb-3 text-end">
                                    <a
                                        href="https://shop.mowa.com/customer/account/forgotpassword/"
                                        target="_blank"
                                        class="forgot-password"
                                        >{{ 'login.forgott_pwd' | translate }}
                                    </a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
